import axios from 'axios';
import type { PackingLogEntry } from '../types/apiTypes';

/** True when packing_log has a non-deleted row for this order number. Throws if the lookup fails. */
export const fetchPackingLogSubmitted = async (orderNumber: string): Promise<boolean> => {
  const response = await axios.get<{ submitted?: unknown }>('/api/supabase/packing-log/submitted', {
    params: { orderNumber },
  });
  if (typeof response.data?.submitted !== 'boolean') {
    throw new Error('Invalid packing log submitted response');
  }
  return response.data.submitted;
};

/** Marks packing_log rows for this order number deleted. Throws if the update fails. */
export const deletePackingLog = async (orderNumber: string): Promise<void> => {
  await axios.delete('/api/supabase/packing-log', { params: { orderNumber } });
};

export const submitPackingLog = async (dataToSubmit: PackingLogEntry[]): Promise<string | undefined> => {
    try {
        const response = await axios.post('/api/packing-log', dataToSubmit);
        if (response.status === 200) {
          return 'Order submitted successfully!';
        }
    } catch (error: unknown) {
        console.error('Error submitting order:', error);
        return 'Failed to submit order.';
    }
};
